import { Calendar, MessageCircle, Sparkles, TrendingUp } from 'lucide-react';
import { LandingTemplate, type LandingData } from '../components/LandingTemplate';
import { LANDING_GUIDES } from '../lib/landingGuides';

const data: LandingData = {
  seo: {
    title: 'Programar publicaciones en Bluesky · Zettapost',
    description:
      'Programa publicaciones en Bluesky desde un único panel. Posiciónate temprano en la red abierta de AT Protocol. Prueba 3 días gratis.',
    canonical: 'https://zettapost.com/programar-bluesky',
  },
  hero: {
    eyebrow: 'Programar Bluesky',
    headlinePre: 'Programa Bluesky',
    headlineAccent: 'mientras la red sigue creciendo.',
    subhead:
      'Lanza tus posts de Bluesky a la hora que tú decidas. Construye tu posicionamiento en la red abierta de AT Protocol sin abrir la app cada 20 minutos.',
    bullets: [
      'Posts con imágenes',
      'Red abierta de AT Protocol',
      'Multi-cuenta',
      '3 días gratis',
    ],
  },
  why: {
    eyebrow: '¿Por qué Zettapost para Bluesky?',
    title: 'Bluesky en serio, sin tener que vivir allí.',
    subtitle:
      'Pensado para creadores, periodistas, marcas tech y agencias que ven el potencial de Bluesky pero no tienen tiempo de estar todo el día publicando.',
    items: [
      {
        Icon: Calendar,
        title: 'Programa a horarios estratégicos',
        description:
          'Programa hora exacta o usa la cola semanal. Zettapost publica solo, también de noche y los fines de semana, mientras tú haces otra cosa.',
      },
      {
        Icon: MessageCircle,
        title: 'Posts con imagen y enlace',
        description:
          'Soportamos posts nuevos con texto, imagen y enlaces — los formatos que mejor funcionan en Bluesky ahora mismo.',
      },
      {
        Icon: Sparkles,
        title: 'IA adaptada a Bluesky',
        description:
          'La IA escribe con el tono cercano y conversacional que funciona en Bluesky, dentro del límite de 300 caracteres y con los hashtags adecuados.',
      },
      {
        Icon: TrendingUp,
        title: 'Crece desde el principio',
        description:
          'Bluesky es de las redes con menos saturación ahora mismo. Publicar consistentemente desde ya te da posicionamiento desproporcionado en tu nicho.',
      },
    ],
  },
  guide: LANDING_GUIDES.bluesky,
  faqs: [
    {
      q: '¿Cómo conecto mi cuenta de Bluesky?',
      a: 'Necesitas tu handle de Bluesky (por ejemplo, marca.bsky.social) y una contraseña de app que generas desde los ajustes de Bluesky. Conectamos vía AT Protocol oficial. Te guiamos paso a paso desde la app.',
    },
    {
      q: '¿Por qué una contraseña de app en vez de OAuth?',
      a: 'Bluesky aún no tiene OAuth público estable, así que la propia plataforma recomienda usar app passwords (contraseñas específicas para apps, revocables en cualquier momento). Es seguro, igual que el flujo de Gmail/Apple.',
    },
    {
      q: '¿Soporta imágenes y enlaces?',
      a: 'Sí. Puedes adjuntar hasta 4 imágenes por post y pegar enlaces con preview automático (card embed), igual que en la app oficial de Bluesky.',
    },
    {
      q: '¿Puedo conectar varias cuentas de Bluesky?',
      a: 'Sí. Los planes con varias cuentas permiten gestionar Bluesky de varios clientes o marcas desde el mismo panel.',
    },
    {
      q: '¿Programáis hilos en Bluesky?',
      a: 'De momento, no: programamos posts sueltos de hasta 300 caracteres, con imágenes. Los hilos y las respuestas se publican desde la app de Bluesky.',
    },
    {
      q: '¿Puedo cross-postear desde X a Bluesky?',
      a: 'Sí. Desde el mismo editor seleccionas las dos redes y se publica adaptando el copy a cada una. Pero recomendamos no copiar literal — Bluesky valora más el tono conversacional propio.',
    },
  ],
  finalCta: {
    title: 'Programa Bluesky',
    titleAccent: 'antes que tu nicho.',
    description: 'Crea tu cuenta y conecta Bluesky gratis durante 3 días.',
  },
  related: [
    { to: '/programar-x', label: 'Programar X' },
    { to: '/programar-threads', label: 'Programar Threads' },
    { to: '/precios', label: 'Ver precios' },
    { to: '/blog', label: 'Blog' },
  ],
};

export function ProgramarBluesky() {
  return <LandingTemplate data={data} />;
}
